import React, { useEffect, useState } from "react";
import TableContainer from "../../../components/layout/table-container/table-container";
import ReasonRejectionListTableData from "./reasonRejectionListTableData";
import { settingsRejectReasonList } from "../../../redux/actions/settingsActions";
import { useDispatch } from "react-redux";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../../components/utilites/loaderSpinningContainer";
import NumberPagination from "../../../components/Pagination/number-pagination";

const ReasonRejectionListTable = ({ search, page_no }) => {
  const dispatch = useDispatch();
  const [rejectReasonData, setRejectReasonData] = useState([]);
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [loading, setLoading] = useState(false);
  const [catchedErrorPopup, setCatchedErrorPopup] = useState(false);
  const [catchedErrorMsg, setCatchedErrorMsg] = useState();

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    fetchRejectReasonList();
  }, [page, search]);

  const fetchRejectReasonList = () => {
    dispatch(settingsRejectReasonList({ search, page }, onSuccess, onError));
    setLoading(true);
  };

  const onSuccess = (data) => {
    setLoading(false);
    setRejectReasonData(data?.data?.data);
  };

  const closeCatchedErrPopup = () => {
    setCatchedErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);
    setCatchedErrorPopup(true);
    setCatchedErrorMsg(err.data.message);
  };

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <>
      <TableContainer>
        <thead>
          <tr className="table-rows color_747f9e">
            <th className="table-heads " width={"4%"}>
              #
            </th>
            <th className="table-heads " width={"15%"}>
              Reasons for Rejection
            </th>
            <th className="table-heads " width={"15%"}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody style={{ position: "relative" }}>
          {loading === true ? (
            <div className="list-spinner-container">
              <LoadingSpinnerTable show={loading} />
            </div>
          ) : rejectReasonData?.rejectionReasons?.length > 0 ? (
            <>
              {rejectReasonData?.rejectionReasons?.map((eachRow, index) => (
                <ReasonRejectionListTableData
                  data={eachRow}
                  key={eachRow.id}
                  index={index}
                  fetchRejectReasonList={fetchRejectReasonList}
                  currentPage={rejectReasonData?.pagination?.currentPage}
                />
              ))}
            </>
          ) : (
            <tr>
              <td colSpan="1" className="text-center no-data-container fs_16">
                <span>~ No Data Found ~</span>
              </td>
            </tr>
          )}
        </tbody>
      </TableContainer>
      <div className={loading === true ? `loading-event` : ""}>
        {rejectReasonData?.pagination?.totalPages > 0 && (
          <NumberPagination
            setCurrentPage={setPage}
            pagination={rejectReasonData?.pagination?.currentPage}
            totalPages={rejectReasonData?.pagination?.totalPages}
            path={"/settings/reason-for-rejection"}
            filters={`${queryString}`}
          />
        )}
      </div>
      <ErrorPopup
        show={catchedErrorPopup}
        title={catchedErrorMsg}
        handleClose={closeCatchedErrPopup}
      />
    </>
  );
};

export default ReasonRejectionListTable;
